import React, {Component} from 'react';
import { connect } from 'react-redux'
import axios from 'axios'
import _ from 'lodash'
import debounce from 'lodash/debounce'
import {toastr} from 'react-redux-toastr'

import { logOut } from '../../auth';

import config from '../../config'

import Translate, {translate} from '../../translate'

class ConsentFormComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      consents: [],
      defaultConsents: ['Jeg samtykker for å bli kontaktet per epost', 'Jeg samtykker for å bli kontaktet per SMS', 'Jeg samtykker til markedsføring basert på mine kjøp og adferd'],
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      preferredLanguage: 'nb',
    }
  }

  componentDidMount() {
    this.getConsents()
    this.getUser()
  }

  getConsents = () => {
    axios.get(`${config.apiUrl}/users/${this.props.user.userId}/consents/${this.props.settings.organizationName}`)
      .then(r => {
        if (r.data && r.data.data && r.data.data[0]) {
          const consent = r.data.data[0]
          this.setState({
            consents: consent.consents,
          })
          const defaultConsents = _.union(this.state.defaultConsents, consent.consents)
          this.setState({defaultConsents: defaultConsents})
        }
      })
      .catch(e => {
        console.error('error: ', e)
        const consentError = translate('consentForm.getConsentError', this.props.settings.language)
        //toastr.error(consentError[0], consentError[1])
      })
  };

  getUser = () => {
    axios.get(`${config.apiUrl}/users/${this.props.user.userId}`)
      .then(r => {
        if (r.data && r.data.data) {
          const user = r.data.data
          this.setState({
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            phone: user.phone || '',
            email: user.email || '',
            preferredLanguage: user.preferredLanguage || 'nb'
          })
        }
      })
      .catch(e => {
        console.error('error: ', e)
        const getUserError = translate('consentForm.getUserError', this.props.settings.language)
        //toastr.error(getUserError[0], getUserError[1])
      })
  };

  updateUser = () => {
    axios.put(`${config.apiUrl}/users/${this.props.user.userId}`, this.state)
      .then(r => {
        toastr.success('Oppdatert')
      })
      .catch(e => {
        console.error('error: ', e)
        const updateUserError = translate('consentForm.updateUserError', this.props.settings.language)
        //toastr.error(updateUserError[0], updateUserError[1])
      })
  };

  saveConsents = () => {
    const data = {
      consents: this.state.consents || [],
    }
    axios.put(`${config.apiUrl}/users/${this.props.user.userId}/consents/${this.props.settings.organizationName}`, data)
      .then(r => {
        const saveConsentSuccess = translate('consentForm.saveConsentSuccess', this.props.settings.language)
        toastr.success(saveConsentSuccess[0], saveConsentSuccess[1])
      })
      .catch(e => {
        console.error('error: ', e)
        const saveConsentError = translate('consentForm.saveConsentError', this.props.settings.language)
        toastr.error(saveConsentError[0], saveConsentError[1])
      })
  };

  checkIfConsentIsActive = (consent) => {
    if (this.state.consents.indexOf(consent) === -1)
      return false
    return true
  };

  secureClassName = (name) => {
    name = name.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~]/g, '');
    name = name.toLowerCase()
    name = name.replace(new RegExp(" ", "g"), '-')
    return name
  };

  toggleConsent = (consent, e) => {
    const consents = [...this.state.consents]
    const index = this.state.consents.indexOf(consent)
    if (index === -1) {
      consents.push(consent)
      this.setState({consents: consents}, () => this.saveConsents())
    } else {
      consents.splice(index, 1)
      this.setState({consents: consents}, () => this.saveConsents())
    }
  };

  deleteMe = () => {
    axios.post(`${config.apiUrl}/delete-me`, {email: this.state.email, org: this.props.settings.organizationName})
      .then(r => {
        const deleteMeSuccess = translate('consentForm.deleteMeSuccess', this.props.settings.language)
        toastr.success(deleteMeSuccess[0], deleteMeSuccess[1])
      })
      .catch(e => {
        const deleteMeError = translate('consentForm.deleteMeError', this.props.settings.language)
        toastr.error(deleteMeError[0], deleteMeError[1])
      })
  };

  render() {
    const {firstName, lastName, phone, email} = this.state
    return (
      <div>
        <form>
          <div>
            <label htmlFor="first-name"><Translate value="consentForm.firstname" language={this.props.settings.language} />:</label>
            <input type="text" 
                   className={this.props.settings.customCssClasses.inputClass} 
                   autoComplete="new-password"
                   id="first-name" 
                   value={firstName} 
                   onChange={e => this.setState({firstName: e.target.value})} 
                   onBlur={e => this.updateUser()} />
          </div>

          <div>
            <label htmlFor="last-name"><Translate value="consentForm.lastname" language={this.props.settings.language} />:</label>
            <input type="text" 
                   className={this.props.settings.customCssClasses.inputClass} 
                   autoComplete="new-password"
                   id="last-name" 
                   value={lastName} 
                   onChange={e => this.setState({lastName: e.target.value})} 
                   onBlur={e => this.updateUser()} />
          </div>

          <div>
            <label htmlFor="phone"><Translate value="consentForm.phone" language={this.props.settings.language} />:</label>
            <input type="tel" 
                   className={this.props.settings.customCssClasses.inputClass} 
                   autoComplete="new-password"
                   id="phone" 
                   value={phone} 
                   onChange={e => this.setState({phone: e.target.value})} 
                   onBlur={e => this.updateUser()} />
          </div>

          <div>
            <label htmlFor="email"><Translate value="consentForm.email" language={this.props.settings.language} />:</label>
            <input type="email" 
                   className={this.props.settings.customCssClasses.inputClass} 
                   autoComplete="new-password"
                   id="email" 
                   value={email} 
                   readOnly />
          </div>

          {this.state.defaultConsents.map((consent, key) => (
            <div key={consent.toLowerCase()}>
              <input type="checkbox" 
                     className={this.props.settings.customCssClasses.checkboxClass} 
                     autoComplete="new-password"
                     id={this.secureClassName(consent)} 
                     value={consent} 
                     checked={this.checkIfConsentIsActive(consent)} 
                     onChange={e => this.toggleConsent(consent, e.target.checked)} />
              <label htmlFor={this.secureClassName(consent)}>&nbsp;<Translate value={`consentForm.consent${key + 1}`} language={this.props.settings.language} /></label>
            </div>
          ))}

          <div>
            <label htmlFor="preferredLanguage"><Translate value="consentForm.preferredLanguage" language={this.props.settings.language} />:</label>
            <select value={this.state.preferredLanguage} 
                    className={this.props.settings.customCssClasses.inputClass} 
                    autoComplete="new-password"
                    id="preferredLanguage"
                    onChange={e => this.setState({preferredLanguage: e.target.value}, e => this.updateUser())}>
              <option value="nb">
                {translate('consentForm.norwegian', this.props.settings.language)}
              </option>
              <option value="en">
                {translate('consentForm.english', this.props.settings.language)}
              </option>
            </select>
          </div>
        </form>

        <a href="" onClick={e => {
          e.preventDefault()
          this.deleteMe()
        }}><Translate value="consentForm.deleteMeButton" language={this.props.settings.language} /></a>

        <br/><a href="/" onClick={e => {
          //e.preventDefault()
          //logOut(this.props.dispatch)
        }}><Translate value="consentForm.saveButton" language={this.props.settings.language} /></a>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    authenticate: state.authenticate,
    layout: state.layout,
    settings: state.settings,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  }
}

const ConsentForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsentFormComponent);

export default ConsentForm



// WEBPACK FOOTER //
// ./src/containers/consent-form/index.js